import React from 'react'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SearchBar = props => {
  return <div className="searchBarConfig"></div>
}

export default SearchBar
